<template>
  <div>
    <div>Таблица, показывающая сколько бы составлял доход по указанным процентам</div>
    <div>Фактическая сумма мотивации (без учета ставки): {{totalEarnMotivate}}</div>
    <b-table
      class="mt-3"
      :items="stats"
      :fields="columns">
    </b-table>
  </div>
</template>

<script>
import {overallWorkshopStatsAct} from '../constants/vuexActions'
import {overallWorkshopStatsGetters as getters} from '../constants/vuexGetters'

export default {
  name: 'StatsWorkshopScreen',
  data () {
    return {
      intervalUpdateWorkerList: null,
      vuexNamespace: 'overallWorkshopStat',
      columns: [
        {
          label: 'Процентное соотношение',
          key: 'percent_sections'
        },
        {
          label: 'Процент от оборота',
          key: 'percent'
        },
        {
          label: 'Доход',
          key: 'profit'
        }
      ]
    }
  },
  computed: {
    stats () {
      return this.getter(getters.TABLE_STATS_M)
    },
    totalEarnMotivate () {
      return this.getter(getters.TOTAL_EARN_MOTIVATE)
    }
  },
  created () {
    this.dispatch(overallWorkshopStatsAct.REQUEST_WORKER_LIST)
    this.dispatch(overallWorkshopStatsAct.REQUEST_TURNOVER_PERCENTS)
    this.intervalUpdateWorkerList = setInterval(
      () => {
        this.dispatch(overallWorkshopStatsAct.REQUEST_WORKER_LIST)
      },
      60000
    )
  },
  beforeDestroy () {
    clearInterval(this.intervalUpdateWorkerList)
  },
  methods: {
    getter (getter) {
      return this.$store.getters[`${this.vuexNamespace}/${getter}`]
    },
    dispatch (action, payload) {
      this.$store.dispatch(`${this.vuexNamespace}/${action}`, payload)
    },
    stateVar (variable) {
      return this.$store.state.callCenter[variable]
    },
    commit (query, payload) {
      this.$store.commit(`${this.vuexNamespace}/${query}`, payload)
    }
  }
}
</script>

<style scoped>
  .hidden-header {
    display:none;
  }
</style>



// WEBPACK FOOTER //
// src/components/StatsWorkshopScreenM.vue